<template>
    <div v-if="rastreador">
        <Suntech300 :rastreador="rastreador"
                    v-if="rastreador.cod_fab_rastreadores === 'SUNTECH' && rastreador.cod_modelo.substring(0, 1) === '3'"/>

        <Suntech410 :rastreador="rastreador"
                    v-if="rastreador.cod_fab_rastreadores === 'SUNTECH' && rastreador.cod_modelo.substring(0, 1) === '4'"/>

        <Delta :rastreador="rastreador"
                    v-if="rastreador.cod_fab_rastreadores === 'DELTA' ||
                    rastreador.cod_fab_rastreadores === 'ONIXSAT' ||
                    rastreador.cod_fab_rastreadores === 'SASCAR'"/>

        <Suntech200 :rastreador="rastreador"
                    v-if="rastreador.cod_fab_rastreadores === 'SUNTECH' && rastreador.cod_modelo.substring(0, 1) === '2'"/>

        <Suntech910 :rastreador="rastreador"
                    v-if="rastreador.cod_fab_rastreadores === 'SUNTECH' && rastreador.cod_modelo.substring(0, 1) === '9'"/>

        <Suntech4G :rastreador="rastreador"
                    v-if="rastreador.cod_fab_rastreadores === 'SUNTECH' && rastreador.cod_modelo.substring(0, 1) === 'S'"/>

        <GenericoG900 :rastreador="rastreador" v-if="usarGenerico"/>
        <Vitana :rastreador="rastreador" v-if="rastreador.cod_fab_rastreadores === 'VITANA'"/>

        <Maxtrack140 :rastreador="rastreador" v-if="rastreador.cod_fab_rastreadores === 'MAXTRACK'"/>

        <Onlink :rastreador="rastreador" v-if="rastreador.cod_fab_rastreadores === 'ONLINK'"/>

        <JMax :rastreador="rastreador" v-if="rastreador.cod_fab_rastreadores === 'JMAX'"/>

        <Concox :rastreador="rastreador"
                v-if="rastreador.cod_fab_rastreadores === 'CONCOX' ||
                    rastreador.cod_fab_rastreadores === 'ACCURATE' ||
                    rastreador.cod_fab_rastreadores === 'LOGICSAT' ||
                    rastreador.cod_fab_rastreadores === 'LOGALL'"/>

        <Oneblock :rastreador="rastreador"
                v-if="rastreador.cod_fab_rastreadores === 'ONEBLOCK' ||
                rastreador.cod_fab_rastreadores === 'CRX1_GENERICO'"/>

        <Rta :rastreador="rastreador"
                  v-if="rastreador.cod_fab_rastreadores === 'RTAGPS'" />

        <TrackerKing :rastreador="rastreador"
                     v-if="rastreador.cod_fab_rastreadores === 'TRACKER_KING'" />

        <Airtag :rastreador="rastreador"
                     v-if="rastreador.cod_fab_rastreadores === 'AIRTAGS' ||
                    (rastreador.cod_fab_rastreadores === 'JIMI'
                    && rastreador.cod_modelo === 'J-TAG')" />

        <Airtag :rastreador="rastreador"
                v-if="rastreador.cod_fab_rastreadores === 'ZHENCB'" />

        <Hinova :rastreador="rastreador"
             v-if="rastreador.cod_fab_rastreadores === 'HINOVA'" />

        <SucreLee :rastreador="rastreador"
                  v-if="rastreador.cod_fab_rastreadores === 'SUCRELEE'"/>

        <Getrak :rastreador="rastreador"
                  v-if="rastreador.cod_fab_rastreadores === 'GETRAK'"/>

        <Nonus :rastreador="rastreador"
        v-if="rastreador.cod_fab_rastreadores === 'NONUS'"/>

        <Wanway :rastreador="rastreador"
                v-if="rastreador.cod_fab_rastreadores === 'WANWAY'"/>

        <nt20 :rastreador="rastreador"
              v-if=" rastreador.cod_fab_rastreadores === 'X3TECH'"/>

        <Queclink :rastreador="rastreador" v-if="rastreador.cod_fab_rastreadores === 'QUECLINK'"/>
        <TK303 :rastreador="rastreador"
               v-if="rastreador.cod_fab_rastreadores === 'TK' ||
               rastreador.cod_fab_rastreadores === 'SINOTRACK' ||
               rastreador.cod_fab_rastreadores === 'H02_GENERICO'"></TK303>
        <CR2000 :rastreador="rastreador" v-if="rastreador.cod_fab_rastreadores === 'CARCELL'"></CR2000>
        <BwsE3 :rastreador="rastreador" v-if="rastreador.cod_fab_rastreadores === 'BWS' || rastreador.cod_fab_rastreadores === 'E3_GENERICO'"></BwsE3>
        <Calamp :rastreador="rastreador" v-if="rastreador.cod_fab_rastreadores === 'CALAMP'"></Calamp>
        <Positron :rastreador="rastreador" v-if="rastreador.cod_fab_rastreadores === 'POSITRON'"></Positron>
        <UniGPS :rastreador="rastreador" v-if="rastreador.cod_fab_rastreadores === 'UNIGPS'"></UniGPS>
        <RST :rastreador="rastreador" v-if="rastreador.cod_fab_rastreadores === 'MULTIPORTAL'"></RST>

    </div>
</template>

<style scoped>
    .page-header {
        margin-top: -5px;
        margin-left: 15px;
        padding-bottom: 5px;
    }
</style>

<script>
    import {Rastreador} from '../../class';
    import Calamp from './Calamp';
    import Positron from './Positron';
    import Delta from './Delta';
    import UniGPS from "./UniGPS";
    import BwsE3 from "./BwsE3";
    import CR2000 from "./CR2000";
    import TK303 from "./TK303";
    import Queclink from "./Queclink";
    import Concox from "./Concox";
    import Maxtrack140 from "./Maxtrack140";
    import Suntech910 from "./Suntech910";
    import Suntech200 from "./Suntech200";
    import Suntech300 from "./Suntech300";
    import RST from "./RST";
    import Suntech410 from "./Suntech410";
    import GenericoG900 from "./Generico-G900";
    import Nt20 from "./Nt20";
    import Vitana from './Vitana.vue';
    import Suntech4G from './Suntech4G.vue';
    import Oneblock from './Oneblock.vue';
    import SucreLee from './SucreLee.vue';
    import Rta from './Rta.vue';
    import Hinova from './Hinova.vue';
    import Onlink from './Onlink.vue';
    import Getrak from './Getrak.vue';
    import Wanway from './Wanway.vue';
    import TrackerKing from './TrackerKing.vue';
    import JMax from './JMax.vue';
    import Airtag from './Airtag.vue';
    import Nonus from './Nonus.vue';

    export default {
        props: {
            id: null
        },

        components: {
            Nonus,
            Airtag,
            JMax,
            TrackerKing,
            Wanway,
            Getrak,
            Onlink,
            Hinova,
            Rta,
            Delta,
            SucreLee,
            Oneblock,
            Suntech4G,
            Vitana,
            Nt20,
            GenericoG900,
            Suntech410,
            RST,
            Suntech300,
            Suntech200,
            Suntech910,
            Maxtrack140,
            Concox,
            Queclink,
            TK303,
            CR2000,
            BwsE3,
            Calamp,
            Positron,
            UniGPS,
        },

        data () {
            return {
                rastreador: null,
                veiculo: null,
            };
        },

        computed: {
            usarGenerico () {
                if (!this.rastreador) {
                    return false;
                }

                const fab = this.rastreador.cod_fab_rastreadores;
                const modelo = this.rastreador.cod_modelo || '';
                const prefixo = modelo.substring(0, 1);

                if (fab === 'GENERICO' && modelo === 'G900') {
                    return true;
                }

                if (fab === 'TKSTAR' || fab === 'ENTRACK') {
                    return true;
                }

                if (fab === 'SUNTECH' && ['2', '3', '4', '9', 'S'].includes(prefixo)) {
                    return false;
                }

                if ([
                    'DELTA', 'ONIXSAT', 'SASCAR',
                    'VITANA', 'MAXTRACK', 'ONLINK', 'JMAX',
                    'CONCOX', 'ACCURATE', 'LOGICSAT', 'LOGALL',
                    'ONEBLOCK', 'CRX1_GENERICO',
                    'RTAGPS', 'TRACKER_KING',
                    'AIRTAGS', 'ZHENCB', 'HINOVA', 'SUCRELEE',
                    'GETRAK', 'NONUS', 'WANWAY', 'X3TECH', 'QUECLINK',
                    'TK', 'SINOTRACK', 'H02_GENERICO',
                    'CARCELL', 'BWS', 'E3_GENERICO',
                    'CALAMP', 'POSITRON', 'UNIGPS', 'MULTIPORTAL',
                ].includes(fab)) {
                    return false;
                }

                if (fab === 'JIMI' && modelo === 'J-TAG') {
                    return false;
                }

                return true;
            },
        },

        async beforeMount () {
            this.rastreador = await Rastreador.byPK(this.id);
        }
    };
</script>
